export default __webpack_public_path__ + "static/media/lap.796bfb02.jpg";